import { FieldObject } from '~/interfaces/field.interface';

export function ip(value?: string) : FieldObject{
    return {
        key: 'IP',
        value,
        tooltip : 'Gateway IP address'
    };
}
export function rfStatus(icon: string, value?: number) : FieldObject{
    return {
        key: 'rfStatus',
        value,
        type: 'icon',
        icon
    };
}

export function connection(icon: string, value?: string | number) : FieldObject {
    return {
        key: 'Connection',
        value,
        type: 'icon',
        icon,
        tooltip : 'Wifi level signal (dB). Must be less than 80 for a correct connection'
    };
}

export function networkLock(value?: boolean, classApplied?: string) : FieldObject{
    return { key: 'Network lock status', value, type: 'boolean', class: classApplied };
}

export function lastDisconnection(value?: number, classApplied?: string) : FieldObject{
    return { key: 'Last Disconnection', value, type: 'last_disconnection', class: classApplied };
}

export function outdated(value: string, classApplied: string) : FieldObject{
    return { key: 'Outdated', value, type: 'string', class: classApplied };
}

export function vpnServer(value?: string) : FieldObject {
    return { key: 'VPN server', value};
}

export function publicIp(value?: string) : FieldObject{
    return { key: 'IP', value, type: 'string' };
}

export function vpnIp(value?: string) : FieldObject{
    return { key: 'VPN IP', value, type: 'string' };
}

export function connectionTime(value?: number, classApplied?: string) : FieldObject{
    return {
        key: 'Connection Time',
        value,
        type: 'date',
        class: classApplied,
        tooltip : 'Last connection date to Wifi network'
    };
}

export function hostServer(value?: string) : FieldObject{
    return {
        key: 'Host Server',
        value,
        type: 'string',
        tooltip : 'Cloud server name associated to the gateway'
    };
}

export function netcomTransport(value?: string, classApplied?: string) : FieldObject{
    return { key: 'Netcom Transport', value, type: 'string', class: classApplied };
}

export function udpIp(value?: string) : FieldObject{
    return {
        key: 'UDP IP',
        value,
        type: 'string',
        tooltip : 'true if the location is determined by IP address'
    };
}

export function udpPusher(value?: string) : FieldObject{
    return { key: 'UDP Pusher', value, type: 'string' };
}

export function connectivity(value?: string) : FieldObject{
    return { key: 'Connectivity', value, type: 'string' };
}
